module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/193.41f945ec.png";